// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__("./node_modules/@pmmmwh/react-refresh-webpack-plugin/client/ReactRefreshEntry.js");
__webpack_require__("./node_modules/webpack-dev-server/client/index.js?http://localhost:3000");
__webpack_require__("./node_modules/react-refresh/runtime.js");
var __webpack_exports__ = __webpack_require__("./client/app/app.tsx");
